type TDirection = "right" | "down" | "left" | "up"

type Props = {
	isActive?: boolean
	direction?: TDirection
}

const DIRECTION_ROTATION: Record<TDirection, string> = {
	right: "rotate(0deg)",
	down: "rotate(90deg)",
	left: "rotate(180deg)",
	up: "rotate(-90deg)",
}

export const ChevronIcon = ({ isActive, direction }: Props) => {
	const transform =
		direction !== undefined ? DIRECTION_ROTATION[direction] : isActive ? "rotate(90deg)" : "rotate(0deg)"
	return (
		<svg
			width="10"
			height="10"
			viewBox="0 0 10 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={{ transform, transition: "transform 0.2s" }}
		>
			<path d="M3 2L6.5 5L3 8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	)
}
